/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HyperInterceptorService } from '@core/http-interceptors/hyper-interceptor.service';
import { AuthInterceptorService } from '@core/http-interceptors/auth-interceptor.service';
import { HeadersInterceptor } from './headers-interceptor.service';

/** Http interceptor providers in outside-in order */
export const HttpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HyperInterceptorService, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true }
];
